import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { AnimationProvider } from "./contexts/animation/AnimationContext";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <AnimationProvider>
      <Router>
        <App />
      </Router>
    </AnimationProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
